import React from "react";
import PropTypes from "prop-types";
import Text from "../Text/Text";
import styles from "./QuestionScreen.module.scss";
import QuestionContainer from "../QuestionContainer/index";

/** Houses the questions along with the intro to the DMA */
function QuestionScreen(props) {
  const { state, handlers } = props;
  return (
    <Container>
      <Wrapper>
        <Text variant="bodyRegular" className={styles.intro}>
          Our DMA will provide detailed and customised reports with clear
          quantitative observations which inform clients on a potential future
          digital roadmap. Answer the questions below to receive your digital
          score across six dimensions.
        </Text>
        <QuestionContainer state={state} handlers={handlers} />
      </Wrapper>
    </Container>
  );
}

function Container(props) {
  const { children } = props;
  return <section className={styles.container}>{children}</section>;
}

Container.propTypes = {
  children: PropTypes.node,
};

/** Wraps the children to provide a max-width */
function Wrapper(props) {
  const { children } = props;

  return <div className={styles.wrapper}>{children}</div>;
}

Wrapper.propTypes = {
  children: PropTypes.node,
};

export default QuestionScreen;
